module.exports = __webpack_public_path__ + "media/img/decorations/contact-us-form-decor-65532c8cb2be5437a18856aa44a35c0f.svg";